import type { UseHttp } from '~/api/interface'

export const fetchExhibitorList: UseHttp = (params, option) => {
  return useHttp.post(`/api/exhibitorApi/list`, params, { ...option })
}
export const exhibitorCheckUser: UseHttp = (params, option) => {
  return useHttp.post(`/api/exhibitorApi/checkUser`, params, { ...option })
}
